import React from "react";

import CompanyRequestFrom from "components/RequestForm";

const RequestForm = () => {
  return <CompanyRequestFrom />;
};

export default RequestForm;
